// import React, { useState } from "react";
// import { Editor } from "@tiptap/core";
// import { useEditor } from "@tiptap/react";
// import ListItem from '@tiptap/extension-list-item';
// import StarterKit from "@tiptap/starter-kit";
// import HardBreak from "@tiptap/extension-hard-break";
// import Placeholder from "@tiptap/extension-placeholder";
// import {
//   MenuButtonBold,
//   MenuButtonItalic,
//   MenuControlsContainer,
//   MenuDivider,
//   MenuSelectHeading,
//   MenuButtonBulletedList,
//   MenuButtonOrderedList,
//   RichTextEditorProvider,
//   RichTextField,
//   RichTextContent,
// } from "mui-tiptap";
// // Import your CSS stylesheets
// import "../styles/variables.css";
// import "../styles/layoutStyles.css";
// import "../styles/buttonStyles.css";
// import "../styles/textStyles.css";

// type TipTapProps = {
//   content: string;
//   alwaysFocus: boolean;
//   placeholder?: string;
//   // onFocus?: () => void;
//   // onBlur?: () => void;
//   onSaveContent: (newContent: string) => void;
// };

// const TipTap: React.FC<TipTapProps> = ({
//   content,
//   alwaysFocus,
//   placeholder,
//   // onFocus,
//   // onBlur,
//   onSaveContent,
// }) => {
//   const [isFocused, setIsFocused] = useState(false);

//   const CustomListItem = ListItem.extend({
//     content: 'text*'
//   });

//   const editorClassName = isFocused
//     ? "editor-focused"
//     : alwaysFocus
//     ? "editor-always-focused"
//     : "";

//   const editor = useEditor({
//     extensions: [
//       StarterKit,
//       Placeholder.configure({
//         placeholder: placeholder,
//       }),
//     ],
//     content: content,
//     editable: true,
//   });

//   // const editor = useEditor({
//   //   extensions: [
//   //     StarterKit.configure({
//   //       history: { depth: 100 },
//   //     }),
//   //     HardBreak.extend({
//   //       addKeyboardShortcuts() {
//   //         return {
//   //           Enter: () => this.editor.commands.setHardBreak(),
//   //         };
//   //       },
//   //     }),
//   //     Placeholder.configure({
//   //       placeholder: placeholder,
//   //     }),
//   //     CustomListItem,
//   //   ],
//   //   content: content,
//   //   editable: true,
//   // });
//   const editor = useEditor({
//     extensions: [
//       StarterKit,
//       HardBreak.extend({
//         addKeyboardShortcuts() {
//           return {
//             Enter: () => this.editor.commands.setHardBreak(),
//           };
//         },
//       }),
//       Placeholder.configure({
//         placeholder: placeholder,
//       }),
//     ],
//     content: content,
//     editable: true,
//   });

//   if (!editor) return null;

//   const handleFocus = () => setIsFocused(true);

//   const handleBlur = (newContent: string) => {
//     setIsFocused(false);
//     onSaveContent(newContent); // Save content when editor loses focus if not empty
//   };

//   // Prevent focus event from propagating
//   const handleMenuClick = (event: React.MouseEvent<HTMLDivElement>) => {
//     event.preventDefault();
//     event.stopPropagation(); // Prevent event from propagating up to the div that handles focus/blur
//     editor.commands.focus(); // Refocus the editor
//   };

//   return (
//     <div className={"tiptap-editor"}>
//       <RichTextEditorProvider editor={editor}>
//         <div
//           className={editorClassName}
//           onFocus={handleFocus}
//           onBlur={() => {
//             const newContent = editor.getHTML();
//             // console.log("newContent: ", newContent);

//             // Create a temporary div element and set its innerHTML to newContent
//             const tempDiv = document.createElement("div");
//             tempDiv.innerHTML = newContent;

//             // Check if the textContent is empty or consists only of whitespace
//             if (
//               tempDiv.textContent !== null &&
//               tempDiv.textContent.trim() === ""
//             ) {
//               alert("Changes not saved as the content cannot be empty. Refreshing the page will revert this to the previously saved content.");
//             } else {
//               handleBlur(newContent); // Save content when editor loses focus and content is not empty
//             }
//           }}
//         >
//           {(isFocused || alwaysFocus) && (
//             <div
//               onMouseDown={handleMenuClick}
//               style={{
//                 display: "flex",
//                 justifyContent: "center",
//                 border: "none",
//               }}
//             >
//               <MenuControlsContainer>
//                 <MenuSelectHeading />
//                 <MenuDivider />
//                 <MenuButtonBold />
//                 <MenuButtonItalic />
//                 <MenuDivider />
//                 <MenuButtonBulletedList />
//                 <MenuButtonOrderedList />
//               </MenuControlsContainer>
//             </div>
//           )}
//           <RichTextContent />
//         </div>
//       </RichTextEditorProvider>
//     </div>
//   );
// };

// export default TipTap;

import React, { useState } from "react";
import { Editor } from "@tiptap/core";
import { useEditor } from "@tiptap/react";
import ListItem from "@tiptap/extension-list-item";
import StarterKit from "@tiptap/starter-kit";
import HardBreak from "@tiptap/extension-hard-break";
import Placeholder from "@tiptap/extension-placeholder";
import {
  MenuButtonBold,
  MenuButtonItalic,
  MenuControlsContainer,
  MenuDivider,
  MenuSelectHeading,
  MenuButtonBulletedList,
  MenuButtonOrderedList,
  RichTextEditorProvider,
  RichTextField,
  RichTextContent,
} from "mui-tiptap";
// Import your CSS stylesheets
import "../styles/variables.css";
import "../styles/layoutStyles.css";
import "../styles/buttonStyles.css";
import "../styles/textStyles.css";

type TipTapProps = {
  content: string;
  alwaysFocus: boolean;
  placeholder?: string;
  onSaveContent: (newContent: string) => void;
};

// const preprocessContent = (content: string) => {
//   return (
//     content
//       // .replace(/\n\n/g, '<br><br>') // Replace double line breaks with <br><br>
//       .replace(/\n/g, "<br>")
//   ); // Replace single line breaks with <br>
// };

const TipTap: React.FC<TipTapProps> = ({
  content,
  alwaysFocus,
  placeholder,
  onSaveContent,
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const CustomListItem = ListItem.extend({
    content: "text*",
  });

  const editorClassName = isFocused
    ? "editor-focused"
    : alwaysFocus
    ? "editor-always-focused"
    : "";

  const editor = useEditor({
    extensions: [
      StarterKit.configure({
        history: { depth: 100 },
      }),
      // HardBreak.extend({
      //   addKeyboardShortcuts() {
      //     return {
      //       Enter: () => this.editor.commands.setHardBreak(),
      //     };
      //   },
      // }),
      Placeholder.configure({
        placeholder: placeholder,
      }),
      CustomListItem,
    ],
    content: content, // Preprocess the content
    editable: true,
  });

  if (!editor) return null;

  const handleFocus = () => setIsFocused(true);

  const handleBlur = (newContent: string) => {
    setIsFocused(false);
    onSaveContent(newContent); // Save content when editor loses focus if not empty
  };

  // Prevent focus event from propagating
  const handleMenuClick = (event: React.MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation(); // Prevent event from propagating up to the div that handles focus/blur
    editor.commands.focus(); // Refocus the editor
  };

  return (
    <div className={"tiptap-editor"}>
      <RichTextEditorProvider editor={editor}>
        <div
          className={editorClassName}
          onFocus={handleFocus}
          onBlur={() => {
            const newContent = editor.getHTML();
            // console.log("newContent: ", newContent);

            // Create a temporary div element and set its innerHTML to newContent
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = newContent;

            // Check if the textContent is empty or consists only of whitespace
            if (
              tempDiv.textContent !== null &&
              tempDiv.textContent.trim() === ""
            ) {
              alert(
                "Changes not saved as the content cannot be empty. Refreshing the page will revert this to the previously saved content."
              );
            } else {
              handleBlur(newContent); // Save content when editor loses focus and content is not empty
            }
          }}
        >
          {(isFocused || alwaysFocus) && (
            <div
              onMouseDown={handleMenuClick}
              style={{
                display: "flex",
                justifyContent: "center",
                border: "none",
              }}
            >
              <MenuControlsContainer>
                <MenuSelectHeading />
                <MenuDivider />
                <MenuButtonBold />
                <MenuButtonItalic />
                <MenuDivider />
                <MenuButtonBulletedList />
                <MenuButtonOrderedList />
              </MenuControlsContainer>
            </div>
          )}
          <RichTextContent className="tiptap-content" />
        </div>
      </RichTextEditorProvider>
    </div>
  );
};

export default TipTap;
